export default __webpack_public_path__ + "static/media/track-min.6c1c734b.mp3";